import { render, staticRenderFns } from "./tradeLeadMessageList.vue?vue&type=template&id=aaa7ff3c&scoped=true&"
import script from "./tradeLeadMessageList.vue?vue&type=script&lang=js&"
export * from "./tradeLeadMessageList.vue?vue&type=script&lang=js&"
import style0 from "./tradeLeadMessageList.vue?vue&type=style&index=0&id=aaa7ff3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa7ff3c",
  null
  
)

export default component.exports